import { Button } from "@/components/ui/button";

type SentryErrorBoundaryFallbackProps = {
  resetError: () => void;
};

export function SentryErrorBoundaryFallback({ resetError }: SentryErrorBoundaryFallbackProps) {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-2xl font-semibold">Something went wrong</h1>
      <p className="text-muted-foreground max-w-md text-sm">
        An unexpected error occurred. The technical details have been logged so we can investigate.
      </p>
      <div className="flex gap-2">
        <Button onClick={resetError} type="button" variant="default">
          Try again
        </Button>
        <Button onClick={() => window.location.reload()} type="button" variant="outline">
          Reload page
        </Button>
      </div>
    </div>
  );
}
